import { Component, Input } from '@angular/core';
import { ConstrainedField } from '@app/shared/models/constrained-field';

@Component({
  selector: 'app-checkbox-cell',
  template: `
<mat-checkbox [formControl]="field.control">
  {{ field.key | translate }}
</mat-checkbox>
`,
  styleUrls: ['./checkbox-cell.component.scss'],
})
export class CheckboxCellComponent {
  @Input() public field!: ConstrainedField;
}
